import { useCallback, useState } from 'react';

/** Ключ выбора пользователя: «1» — свёрнуто, «0» — раскрыто; пусто — выбора ещё не было. */
const KLYUCH = 'opsmind.menyu.svernuto';

/** До этой ширины окна меню при первом входе показывается свёрнутым. */
const UZKIY_EKRAN_PX = 1366;

function nachalnoe(): boolean {
  try {
    const sohranyonnoe = window.localStorage.getItem(KLYUCH);
    if (sohranyonnoe === '1') return true;
    if (sohranyonnoe === '0') return false;
  } catch {
    // Хранилище недоступно (приватный режим) — решает ширина окна.
  }

  return typeof window !== 'undefined' && window.innerWidth <= UZKIY_EKRAN_PX;
}

/**
 * СВЁРНУТОЕ ГЛАВНОЕ МЕНЮ (`s698`, владелец 04.10.2026: «сворачиваемое главное
 * боковое меню, как в amo» — для небольших экранов менеджеров).
 *
 * ⛔ ВЫБОР ЧЕЛОВЕКА ПОБЕЖДАЕТ ШИРИНУ. Пока он не нажал переключатель, на окне до
 * 1366 px меню свёрнуто, шире — раскрыто. Нажал — запоминаем его слово и больше
 * за него не решаем: ни при переходах, ни после перезагрузки.
 */
export function useSvernutoeMenyu(): [boolean, () => void] {
  const [svernuto, setSvernuto] = useState<boolean>(nachalnoe);

  const pereklyuchit = useCallback(() => {
    setSvernuto((bylo) => {
      const stalo = !bylo;
      try {
        window.localStorage.setItem(KLYUCH, stalo ? '1' : '0');
      } catch {
        // Не запомнилось — меню всё равно переключилось на этот заход.
      }

      return stalo;
    });
  }, []);

  return [svernuto, pereklyuchit];
}
